/* engine/handlePlace.js — ADMIN HANDLE PLACEMENT (2026-08-10): exact-mm position of the handle
 * on its front rect. The technician authors the allowed positions per handle (Handles → +
 * Position); the customer only picks BETWEEN them, never free.
 *
 * Lifted VERBATIM out of scene3d/sceneBuilders (2026-09-12) so the elevation drawing — a pure,
 * THREE-free module — places every handle with the SAME rule the 3D mounts it by. sceneBuilders
 * re-exports both, so every existing import path still works.
 *
 * rect = {w, h, cx, cy, openSign} in the mount parent's local frame
 * (openSign: door opening-edge direction, 0 for drawers → centre). */

/** per-front placement pick: vis.handlePlaceByFront["door-N"|"drawer-N"]
 *  (spec order) wins over the module-level vis.handlePlace. */
export function handlePlaceFor(vis, frontKey) {
  if (!vis) return null;
  const per = vis.handlePlaceByFront;
  if (per && frontKey && per[frontKey]) return per[frontKey];
  return vis.handlePlace || null;
}

export function handlePlacePos(hp, rect, dflt) {
  if (!hp) return { x: dflt.x, y: dflt.y || 0, z: dflt.z, rotZ: 0 };
  const mm = (v) => (Number(v) || 0) / 1000;
  let x;
  if (hp.h === "left") x = rect.cx - rect.w / 2 + mm(hp.hMm);
  else if (hp.h === "right") x = rect.cx + rect.w / 2 - mm(hp.hMm);
  else if (hp.h === "edge" && rect.openSign) x = rect.cx + rect.openSign * (rect.w / 2 - mm(hp.hMm));
  else if (hp.h === "edge") x = rect.cx;
  else x = rect.cx + mm(hp.hMm);          // centre + signed offset
  let y;
  if (hp.v === "top") y = rect.cy + rect.h / 2 - mm(hp.vMm);
  else if (hp.v === "bottom") y = rect.cy - rect.h / 2 + mm(hp.vMm);
  else y = rect.cy + mm(hp.vMm);          // middle + signed offset (up = +)
  return { x, y, z: dflt.z, rotZ: ((Number(hp.rot) || 0) * Math.PI) / 180 };  // any degrees (90, 180, 35…)
}
